import React from 'react'
import PropTypes from 'prop-types'
import {
    Modal,
    ModalBody,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    useMultiStyleConfig,
} from '@chakra-ui/react'
import CloseIcon from '../../icons/action/CloseIcon'
import GalleryBody from './gallery-body'

const GalleryModal = ({
    imageGroups = [],
    selectedVariationAttributes = {},
    isOpen,
    lazy = false,
    closeModal,
    openModal,
    videoUrl,
    isModalGallerySwiper,
    setIsModalGallerySwiper,
    modalInitValue,
    powerImages = [],
}) => {
    const styles = useMultiStyleConfig('GalleryModal')
    return (
        <Modal isOpen={isOpen} size="full">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader {...styles.galleryModalHeader}>
                    <CloseIcon data-testid="close-modal-button" onClick={closeModal} />
                </ModalHeader>
                <ModalBody {...styles.galleryModalBody}>
                    <GalleryBody
                        imageGroups={imageGroups}
                        selectedVariationAttributes={selectedVariationAttributes}
                        lazy={lazy}
                        openModal={openModal}
                        variant="inModal"
                        isModalOpen={isOpen}
                        videoUrl={videoUrl}
                        isModalGallerySwiper={isModalGallerySwiper}
                        setIsModalGallerySwiper={setIsModalGallerySwiper}
                        modalInitValue={modalInitValue}
                        powerImages={powerImages}
                    />
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

GalleryModal.propTypes = {
    imageGroups: PropTypes.array,
    isOpen: PropTypes.bool,
    lazy: PropTypes.bool,
    closeModal: PropTypes.func,
    openModal: PropTypes.func,
    selectedVariationAttributes: PropTypes.object,
    videoUrl: PropTypes.string,
    styles: PropTypes.object,
    isModalGallerySwiper: PropTypes.bool,
    setIsModalGallerySwiper: PropTypes.func,
    modalInitValue: PropTypes.number,
    powerImages: PropTypes.array,
}

export default GalleryModal
